(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6021],{

/***/ 86586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disfruta-de-la-cerveza-a-domicilio",
      function () {
        return __webpack_require__(40354);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71888);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65900);
/* harmony import */ var _layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31247);



// TODO: Añadir tipos
var ComoRegalar = function(param) {
    var _page = param.page, hero = _page.hero, flexibleContent = _page.flexibleContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_1__/* .HeroSlider */ .r, {
                hero: hero
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_2__/* .FlexibleContent */ .U, {
                type: "Page",
                flexible: flexibleContent.flexible
            })
        ]
    });
};
ComoRegalar.getLayout = _layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_3__/* .getBaseLayout */ .W;
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ComoRegalar);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2033,7677,1247,1888,9774,2888,179], function() { return __webpack_exec__(86586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);